import { render, staticRenderFns } from "./AssignBusinessModal.vue?vue&type=template&id=cf7ccec0&v-if=selectedBusiness.length%20%3E%200&"
import script from "./AssignBusinessModal.vue?vue&type=script&lang=js&"
export * from "./AssignBusinessModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports